(function () {
  'use strict';
  const node = document.querySelector('[data-grayish-stock-config]');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  function limitMessage(limit) {
    return limit === 0 ? config.sold_out : config.limit.replace('__limit__', String(limit));
  }
  function showError(message, container) {
    if (!container) return;
    let note = container.querySelector(':scope > [data-grayish-stock-error]');
    if (!note) {
      note = document.createElement('p');
      note.dataset.grayishStockError = '';
      note.setAttribute('role', 'alert');
      note.style.cssText = 'color:#9e2525;margin:12px 0;padding:10px;font-size:14px;line-height:1.5;';
      container.appendChild(note);
    }
    note.textContent = message;
    note.hidden = false;
  }
  function clearError(container) {
    container?.querySelectorAll('[data-grayish-stock-error]').forEach(note => { note.hidden = true; });
  }
  function apiError(data) {
    const message = data?.description || data?.message || config.request_failed;
    return /stock|available|sold out|can't add more/i.test(message) ? config.at_limit : message;
  }
  async function readJson(response) {
    let data;
    try { data = await response.json(); } catch (_) { throw new Error(config.request_failed); }
    if (!response.ok) throw new Error(apiError(data));
    return data;
  }
  async function loadSnapshot() {
    const url = new URL(config.cart_url, window.location.origin);
    url.searchParams.set('section_id', 'grayish-cart-stock');
    url.searchParams.set('_stock', String(Date.now()));
    const response = await fetch(url.pathname + url.search, { cache: 'no-store' });
    if (!response.ok) throw new Error(config.request_failed);
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const script = html.querySelector('[data-grayish-cart-stock]');
    if (!script) throw new Error(config.request_failed);
    const snapshot = JSON.parse(script.textContent);
    if (!Array.isArray(snapshot.items)) throw new Error(config.request_failed);
    return snapshot;
  }
  function maxForLine(snapshot, key) {
    const item = snapshot.items.find(line => line.key === key);
    if (!item || item.limit === null) return null;
    const other = snapshot.items.filter(line => String(line.variant_id) === String(item.variant_id) && line.key !== key)
      .reduce((sum, line) => sum + line.quantity, 0);
    return Math.max(0, item.limit - other);
  }
  function variantStock(form) {
    const script = form?.querySelector('[data-grayish-variant-stock]');
    const id = new FormData(form).get('id');
    if (!script || !id) return null;
    return JSON.parse(script.textContent).find(variant => String(variant.id) === String(id)) || null;
  }
  function syncInput(input) {
    const form = input?.closest('form[action*="/cart/add"]');
    if (!form) return;
    const variant = variantStock(form);
    if (!variant) return;
    input.dataset.stockVariantId = variant.id;
    if (variant.limit === null) input.removeAttribute('max');
    else input.max = variant.limit;
    const max = variant.limit === null ? Infinity : variant.limit;
    const selector = input.closest('quantity-selector');
    const plus = selector?.querySelector('[data-quantity-plus]');
    if (plus) plus.disabled = Number(input.value) >= max;
    selector?.querySelector('[data-button-wrapper-plus]')?.classList.toggle('quantity-selector__button-wrapper--disabled', Number(input.value) >= max);
    const hint = selector?.querySelector('[data-grayish-stock-hint]');
    if (hint) hint.hidden = !(Number(input.value) >= max);
  }
  async function checkAdd(form) {
    const variant = variantStock(form);
    if (!variant || variant.limit === null) return;
    const input = form.querySelector('[name="quantity"]');
    syncInput(input);
    const quantity = Number(new FormData(form).get('quantity') || 1);
    const snapshot = await loadSnapshot();
    const existing = snapshot.items.filter(line => String(line.variant_id) === String(variant.id));
    const total = existing.reduce((sum, line) => sum + line.quantity, 0);
    const limit = existing.length ? existing[0].limit : variant.limit;
    if (limit !== null && (limit === 0 || total + quantity > limit)) throw new Error(limitMessage(limit));
  }
  function updateForm(form) {
    form.querySelectorAll('[data-quantity-input]').forEach(input => {
      syncInput(input);
      const max = input.max === '' ? Infinity : Number(input.max);
      if (Number(input.value) > max && max > 0) {
        input.value = max;
        showError(limitMessage(max), form);
      }
    });
  }
  window.GrayishStock = { config, loadSnapshot, maxForLine, limitMessage, showError, clearError, readJson, apiError, syncInput, checkAdd };
  document.addEventListener('change', event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (form) {
      setTimeout(() => updateForm(form), 0);
      setTimeout(() => updateForm(form), 150);
    }
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-plus], .shopify-payment-button__button');
    const form = button?.closest('form[action*="/cart/add"]');
    if (form) updateForm(form);
  }, true);
  document.querySelectorAll('form[action*="/cart/add"]').forEach(updateForm);
})();
